export var TableCellContentType;
(function (TableCellContentType) {
    TableCellContentType["DND"] = "DND";
    TableCellContentType["CHECKBOX"] = "CHECKBOX";
    TableCellContentType["ACTION"] = "ACTION";
    TableCellContentType["LOADING"] = "LOADING";
    TableCellContentType["NO_PADDING"] = "NO_PADDING";
})(TableCellContentType || (TableCellContentType = {}));
